// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import storage from './common/utils/storage'
import { baseUrl, imageBaseUrl, mapSrverUrl } from './config/env'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
import './assets/iconfont/iconfont'
import * as echarts from 'echarts'
import axios from 'axios'
import Sortable from 'sortablejs'
import * as mars3d from "mars3d"


import { checkPermission } from '@/common/utils/permission.js'

import VueClipboard from 'vue-clipboard2'


Vue.use(VueClipboard)

Vue.use(ElementUI)

import Print from 'vue-print-nb'
Vue.use(Print)

import "mars3d/dist/mars3d.css"
import { useGlobelComponents } from './components/globelComponents'

useGlobelComponents(Vue)

window.mars3d = mars3d


// import i18n from './common/i18n'
// Vue.use(ElementUI,{
//   i18n:(key,value) => i18n.t(key,value)
// });   //全部引入   可以根据需求按需引入

Vue.prototype.$storage = storage          //设置全局缓存属性
Vue.prototype.$eventBus = new Vue()
Vue.prototype.$checkPermission = checkPermission      //全局检验权限方法
Vue.prototype.$echarts = echarts     //设置全局柱状图
Vue.prototype.$http = axios
Vue.prototype.$Sortable = Sortable
Vue.prototype.$baseUrl = baseUrl
Vue.prototype.$imageBaseUrl = imageBaseUrl
Vue.prototype.$mapSrverUrl = mapSrverUrl

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js